import { createRootRoute, Outlet, Link } from "@tanstack/react-router";
import { useUser } from "../context/UserContext";
import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import Loader from "../components/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import packageJson from "../../package.json";
import NotFound from "../components/NotFound/NotFound";

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFound,
});

function RootComponent() {
  const { user, loading } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // Allow public pages without redirecting to login
    const publicPaths = ["/privacy-policy", "/contact", "/terms-of-service", "/about"];
    const currentPath = window.location.pathname;

    if (!user && !loading && !publicPaths.includes(currentPath)) {
      navigate({ to: "/login", resetScroll: false });
    } else if (
      (user && currentPath === "/login") ||
      (user && currentPath === "/")
    ) {
      navigate({ to: "/dashboard", resetScroll: true });
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <Outlet />
      <ToastContainer hideProgressBar={true} position={"top-center"} />
      <div className={"text-zinc-600 text-xs text-center py-2"}>
        <div className="flex justify-center items-center gap-4">
          <span>v{packageJson?.version}</span>
          <span>•</span>
          <Link
            to="/contact"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Contact
          </Link>
          <span>•</span>
          <Link
            to="/privacy-policy"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
      {/*<TanStackRouterDevtools />*/}
    </div>
  );
}
